import Footer from '@/renderer/Footer';
import Header from '@/renderer/Header';
import { usePageContext } from '@/renderer/utils/usePageContext';

export default NotificationsPage;

export function Notifications() {
  const {
    config: { title },
  } = usePageContext();

  return (
    <>
      <Header title="Notifications" className="sm:hidden" />
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="relative mx-auto max-w-2xl py-4 pt-0 text-center sm:pb-24 sm:pt-20">
          <h1 className="hidden text-3xl font-bold tracking-tight text-zinc-900 dark:text-zinc-200 sm:block sm:text-4xl">
            {title}
          </h1>
          <p className="mt-4 text-left text-xs leading-7 text-zinc-600 dark:text-zinc-400 sm:text-center sm:text-base">
            Last updated on October 23, 2023
          </p>
        </div>
      </div>
      <div className="relative px-4 sm:px-6 lg:px-8">
        <div className="prose prose-sm prose-zinc max-w-prose dark:prose-invert prose-a:font-semibold prose-a:text-emerald-500 prose-a:hover:text-emerald-600 sm:mx-auto">
          <p>
            By default, we subscribe you to the following announcement and activity email
            notifications. You can change your notification settings at any time in your account
            settings.
          </p>
          <ul>
            <li>
              <b>Free plays & promos: </b> Free plays, service announcements, promotions and other
              marketing emails.
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </>
  );
}

// Main component
function NotificationsPage() {
  return <Notifications />;
}
